const setSearchViewMode = (mode = "mapView") => {
    localStorage.setItem("SearchViewMode", mode);
}

const getSerachViewMode = () => {
    if(localStorage.getItem("SearchViewMode") == null ) {
        setSearchViewMode();
    }
    return localStorage.getItem("SearchViewMode");
}

export { setSearchViewMode, getSerachViewMode }